import pic from "./image/cap-and-gown.jpg";
import staff from "./image/faculty/staff1.jpg";
import Staff1 from "./image/faculty/staff1.jpg";
import Staff2 from "./image/faculty/staff2.jpg";
import Staff3 from "./image/faculty/staff3.jpg";
import Staff4 from "./image/faculty/staff4.jpg";
import Staff5 from "./image/faculty/staff5.jpg";
import Staff6 from "./image/faculty/staff6.jpg";
import Staff7 from "./image/faculty/staff7.jpg";
import Staff8 from "./image/faculty/staff8.jpg";
import Staff9 from "./image/faculty/staff9.jpg";
import Staff10 from "./image/faculty/staff10.jpg";
import Staff11 from "./image/faculty/staff11.jpg";
import Staff12 from "./image/faculty/staff12.jpg";
import Staff13 from "./image/faculty/staff13.jpg";
import Staff14 from "./image/faculty/staff14.jpg";
import Staff15 from "./image/faculty/staff15.jpg";
import Staff16 from "./image/faculty/staff16.jpg";
import library from "./image/library.jpg";
import cafeteria from "./image/canteen.png";
import laboratoryRoom from "./image/laboratory.jpg";
import auditorium from "./image/auditorium.jpg";

export const FacultyStaffList = [
  {
    image: Staff1,
    name: "John Doe",
    position: "Manager",
  },
  {
    image: Staff2,
    name: "Jane Smith",
    position: "Assistant Manager",
  },
  {
    image: Staff3,
    name: "Michael Brown",
    position: "Lead Developer",
  },
  {
    image: Staff4,
    name: "Emily Davis",
    position: "Designer",
  },
  {
    image: Staff5,
    name: "David Wilson",
    position: "HR Specialist",
  },
  {
    image: Staff6,
    name: "Sophia Johnson",
    position: "Marketing Manager",
  },
  {
    image: Staff7,
    name: "James Taylor",
    position: "Sales Executive",
  },
  {
    image: Staff8,
    name: "Olivia Lee",
    position: "Customer Support",
  },
  {
    image: Staff9,
    name: "Chris Martin",
    position: "Product Manager",
  },
  {
    image: Staff10,
    name: "Natalie Evans",
    position: "Finance Officer",
  },
  {
    image: Staff11,
    name: "Daniel Garcia",
    position: "Operations Manager",
  },
  {
    image: Staff12,
    name: "Ava Robinson",
    position: "Content Writer",
  },
  {
    image: Staff13,
    name: "Robert King",
    position: "Data Analyst",
  },
  {
    image: Staff14,
    name: "Ella Scott",
    position: "SEO Specialist",
  },
  {
    image: Staff15,
    name: "Lucas Moore",
    position: "Full Stack Developer",
  },
  {
    image: Staff16,
    name: "Grace Turner",
    position: "UI/UX Designer",
  },
];

export const events = [
  {
    date: "2024-08-27",
    day: "Tue",
    title: "Welcome Walk and Students General Orientation",
  },
  {
    date: "2024-08-29",
    day: "Thu",
    title: "General PTA Assembly",
  },
  {
    date: "2024-08-31",
    day: "Sat",
    title: "Buwan ng Wika Culminating Activity",
  },
  {
    date: "2024-09-01",
    day: "Sun",
    title: "Opening of Science Month Celebration",
  },
  {
    date: "2024-10-07",
    day: "Mon",
    title: "World’s Teachers Day Celebration",
  },
  {
    date: "2024-10-19",
    day: "Sat",
    title: "Intramurals & Foundation Day",
  },
  {
    date: "2024-10-20",
    day: "Sun",
    title: "Intramurals & Foundation Day",
  },
  {
    date: "2024-10-31",
    day: "Thu",
    title: "United Nations Month Culminating Activity",
  },
  {
    date: "2024-12-22",
    day: "Sun",
    title: "Faculty & Staff Year-end Get Together",
  },
];

export const news = [
  // {
  //   id: 1,
  //   title: "JMIF Celebrates Class of 2024 Graduation",
  //   date: "July 2, 2024",
  //   location: "Iligan City",
  //   subContent:
  //     "JMIF proudly celebrated the graduation of the Class of 2024 on July 1 in a memorable ceremony held at Iligan City. The event was attended by proud families, friends, faculty, and staff, who gathered to honor the achievements of this exceptional group of students.",
  //   content: [
  //     {
  //       id: 1,
  //       text: "Iligan City, July 2, 2024 – JMIF proudly celebrated the <strong>graduation of the Class of 2024</strong> on June 14, 2024, in a memorable ceremony held at the Grand Auditorium. The event was attended by proud families, friends, faculty, and staff, who gathered to honor the achievements of this exceptional group of students.",
  //     },
  //     {
  //       id: 2,
  //       text: "The ceremony commenced with a stirring rendition of the national anthem performed by the school choir, followed by an inspiring address from the President of JMIF, Dr. Sarah Thompson. In her speech, she commended the graduates for their hard work, resilience, and dedication, highlighting the remarkable milestones they have achieved during their time at JMIF.",
  //     },
  //     {
  //       id: 3,
  //       text: '"Today, we celebrate not just the completion of your academic journey, but the beginning of new and exciting opportunities," said Dr. Thompson. "You have shown incredible strength and perseverance, and we are confident that you will continue to achieve great things in the future."',
  //     },
  //     {
  //       id: 4,
  //       text: 'Valedictorian Emily Rodriguez delivered a heartfelt speech, reflecting on the shared experiences and memories that have shaped the class. "We have grown together, learned together, and now, we step forward together into the next chapter of our lives," Emily said. "Let us carry the lessons we have learned and the friendships we have made as we embark on our new adventures."',
  //     },
  //   ],
  //   image: pic, // Import the image as needed
  // },
];

export const AlumniNews = [
  {
    id: 1,
    title: "JMIF Celebrates Class of 2024 Graduation",
    date: "July 2, 2024",
    location: "Iligan City",
    subContent: `Reconnect with fellow JMIF graduates at our Alumni Homecoming! Enjoy a
          day of activities, including a welcome reception, campus tours, and a
          special dinner. Whether recent or long-time alumni, join us in
          celebrating the JMIF spirit and making new memories together. We can’t
          wait to welcome you back!`,
    content: [
      {
        id: 1,
        text: "Iligan City, July 2, 2024 – JMIF proudly celebrated the <strong>graduation of the Class of 2024</strong> on June 14, 2024, in a memorable ceremony held at the Grand Auditorium. The event was attended by proud families, friends, faculty, and staff, who gathered to honor the achievements of this exceptional group of students.",
      },
      {
        id: 2,
        text: "The ceremony commenced with a stirring rendition of the national anthem performed by the school choir, followed by an inspiring address from the President of JMIF, Dr. Sarah Thompson. In her speech, she commended the graduates for their hard work, resilience, and dedication, highlighting the remarkable milestones they have achieved during their time at JMIF.",
      },
      {
        id: 3,
        text: '"Today, we celebrate not just the completion of your academic journey, but the beginning of new and exciting opportunities," said Dr. Thompson. "You have shown incredible strength and perseverance, and we are confident that you will continue to achieve great things in the future."',
      },
      {
        id: 4,
        text: 'Valedictorian Emily Rodriguez delivered a heartfelt speech, reflecting on the shared experiences and memories that have shaped the class. "We have grown together, learned together, and now, we step forward together into the next chapter of our lives," Emily said. "Let us carry the lessons we have learned and the friendships we have made as we embark on our new adventures."',
      },
    ],
    image: pic, // Import the image as needed
  },
  {
    id: 2,
    title: "New Science Building Inauguration at JMIF",
    date: "September 10, 2024",
    location: "Iligan City",
    subContent:
      "JMIF proudly celebrated the graduation of the Class of 2024 on July 1 in a memorable ceremony held at Iligan City. The event was attended by proud families, friends, faculty, and staff, who gathered to honor the achievements of this exceptional group of students.",

    content: [
      {
        id: 1,
        text: "Iligan City, September 10, 2024 – JMIF celebrated the grand opening of its new state-of-the-art science building. The building is designed to enhance research and innovation, providing students and faculty with cutting-edge facilities.",
      },
      {
        id: 2,
        text: "The inauguration event was attended by esteemed guests, including government officials, industry leaders, and alumni. Dr. Sarah Thompson, President of JMIF, expressed her excitement for the new opportunities the building would bring to the students and the community.",
      },
      {
        id: 3,
        text: '"This new science facility represents our commitment to advancing education and research," said Dr. Thompson. "It will allow our students to explore new scientific frontiers and develop skills critical for the 21st century."',
      },
      {
        id: 4,
        text: "The new building includes modern laboratories, collaborative workspaces, and a research library, providing an unparalleled environment for students to excel in their studies and contribute to meaningful scientific advancements.",
      },
    ],
    image: staff, // Import the image as needed
  },
  {
    id: 3,
    title: "Congratulations to Our PNLE Passers",
    date: "May 7, 2024",
    location: "Cagayan de Oro City",
    subContent:
      "JMIF proudly celebrated the graduation of the Class of 2024 on July 1 in a memorable ceremony held at Iligan City. The event was attended by proud families, friends, faculty, and staff, who gathered to honor the achievements of this exceptional group of students.",

    content: [
      {
        id: 1,
        text: "To our Graduates who passed the Philippine Nursing Licensure Examination (PNLE) given on May 6-7, 2024 at Cagayan de Oro City, we extend our heartfelt congratulations.",
      },
      {
        id: 2,
        text: "We are immensely proud of your achievement and commend your dedication and hard work in reaching this significant milestone in your nursing career.",
      },
      {
        id: 3,
        text: "With 44 passers from our institution, this accomplishment is a testament to your commitment and the quality of education you have received.",
      },
      {
        id: 4,
        text: "As you embark on your professional journey, we wish you success and fulfillment in your nursing practice. Your achievement is just the beginning of many more accomplishments to come.",
      },
    ],
    image: staff, // Example image path
  },
  {
    id: 5,
    title: "test4",
    date: "July 2, 2024",
    location: "Iligan City",
    subContent:
      "JMIF proudly celebrated the graduation of the Class of 2024 on July 1 in a memorable ceremony held at Iligan City. The event was attended by proud families, friends, faculty, and staff, who gathered to honor the achievements of this exceptional group of students.",

    content: [
      {
        id: 1,
        text: "Iligan City, July 2, 2024 – JMIF proudly celebrated the <strong>graduation of the Class of 2024</strong> on June 14, 2024, in a memorable ceremony held at the Grand Auditorium. The event was attended by proud families, friends, faculty, and staff, who gathered to honor the achievements of this exceptional group of students.",
      },
      {
        id: 2,
        text: "The ceremony commenced with a stirring rendition of the national anthem performed by the school choir, followed by an inspiring address from the President of JMIF, Dr. Sarah Thompson. In her speech, she commended the graduates for their hard work, resilience, and dedication, highlighting the remarkable milestones they have achieved during their time at JMIF.",
      },
      {
        id: 3,
        text: '"Today, we celebrate not just the completion of your academic journey, but the beginning of new and exciting opportunities," said Dr. Thompson. "You have shown incredible strength and perseverance, and we are confident that you will continue to achieve great things in the future."',
      },
      {
        id: 4,
        text: 'Valedictorian Emily Rodriguez delivered a heartfelt speech, reflecting on the shared experiences and memories that have shaped the class. "We have grown together, learned together, and now, we step forward together into the next chapter of our lives," Emily said. "Let us carry the lessons we have learned and the friendships we have made as we embark on our new adventures."',
      },
    ],
    image: pic, // Import the image as needed
  },
  {
    id: 6,
    title: "test4",
    date: "July 2, 2024",
    location: "Iligan City",
    subContent:
      "JMIF proudly celebrated the graduation of the Class of 2024 on July 1 in a memorable ceremony held at Iligan City. The event was attended by proud families, friends, faculty, and staff, who gathered to honor the achievements of this exceptional group of students.",
    content: [
      {
        id: 1,
        text: "Iligan City, July 2, 2024 – JMIF proudly celebrated the <strong>graduation of the Class of 2024</strong> on June 14, 2024, in a memorable ceremony held at the Grand Auditorium. The event was attended by proud families, friends, faculty, and staff, who gathered to honor the achievements of this exceptional group of students.",
      },
      {
        id: 2,
        text: "The ceremony commenced with a stirring rendition of the national anthem performed by the school choir, followed by an inspiring address from the President of JMIF, Dr. Sarah Thompson. In her speech, she commended the graduates for their hard work, resilience, and dedication, highlighting the remarkable milestones they have achieved during their time at JMIF.",
      },
      {
        id: 3,
        text: '"Today, we celebrate not just the completion of your academic journey, but the beginning of new and exciting opportunities," said Dr. Thompson. "You have shown incredible strength and perseverance, and we are confident that you will continue to achieve great things in the future."',
      },
      {
        id: 4,
        text: 'Valedictorian Emily Rodriguez delivered a heartfelt speech, reflecting on the shared experiences and memories that have shaped the class. "We have grown together, learned together, and now, we step forward together into the next chapter of our lives," Emily said. "Let us carry the lessons we have learned and the friendships we have made as we embark on our new adventures."',
      },
    ],
    image: pic, // Import the image as needed
  },
  {
    id: 4,
    title: "test4",
    date: "July 2, 2024",
    location: "Iligan City",
    content: [
      {
        id: 1,
        text: "Iligan City, July 2, 2024 – JMIF proudly celebrated the <strong>graduation of the Class of 2024</strong> on June 14, 2024, in a memorable ceremony held at the Grand Auditorium. The event was attended by proud families, friends, faculty, and staff, who gathered to honor the achievements of this exceptional group of students.",
      },
      {
        id: 2,
        text: "The ceremony commenced with a stirring rendition of the national anthem performed by the school choir, followed by an inspiring address from the President of JMIF, Dr. Sarah Thompson. In her speech, she commended the graduates for their hard work, resilience, and dedication, highlighting the remarkable milestones they have achieved during their time at JMIF.",
      },
      {
        id: 3,
        text: '"Today, we celebrate not just the completion of your academic journey, but the beginning of new and exciting opportunities," said Dr. Thompson. "You have shown incredible strength and perseverance, and we are confident that you will continue to achieve great things in the future."',
      },
      {
        id: 4,
        text: 'Valedictorian Emily Rodriguez delivered a heartfelt speech, reflecting on the shared experiences and memories that have shaped the class. "We have grown together, learned together, and now, we step forward together into the next chapter of our lives," Emily said. "Let us carry the lessons we have learned and the friendships we have made as we embark on our new adventures."',
      },
    ],
    image: pic, // Import the image as needed
  },
];

export const AlumniMedia = [Staff1, Staff2, Staff3, Staff4, Staff5, Staff6];
export const facilitiesList = [
  {
    id: 1,
    image: library,
    name: "Library",
    description: "A quiet place with a vast collection of books and resources.",
  },

  {
    id: 3,
    image: cafeteria,
    name: "Cafeteria",
    description: "A place to enjoy meals and snacks with friends.",
  },

  {
    id: 5,
    image: auditorium,
    name: "Auditorium",
    description: "A large venue for events, presentations, and lectures.",
  },
  {
    id: 13,
    image: laboratoryRoom, // Add your image for the laboratory room
    name: "Laboratory Room",
    description:
      "A specialized space for conducting experiments and practical learning in various sciences.",
  },
];
